import React from "react";
import { getBoundingClientRect } from "../../utils/functions";
import { checkTranslation } from "../../utils/useful";
import i18n from "../../i18n";

var moment = require('jalali-moment');

class DateInput extends React.Component {

    state = {
        // title: moment(),
        isOpen: false,
        startOfMonth: '',
        endOfMonth: '',
        week: ['شنبه', '۱شنبه', '۲شنبه', '۳شنبه', '۴شنبه', '۵شنبه', 'جمعه'],
        days: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,],
        month: { startDay: 0, daysCount: 30 },
        monthFromNow: 0,
        today: '',
        showYearPicker: false,
        // currentTime
    }

    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }


    componentWillMount() {
        const todayTimestamp = new Date().getTime()
        const hasInitialDate = !!this.props.data

        // Base today and title
        this.setState({ title: this.props.data, today: todayTimestamp })

        // If we have an initial date, open calendar on that exact month/year
        if (hasInitialDate) {
            const selected = moment(this.props.data)

            if (selected.isValid()) {
                this.setMonth(0, this.props.data)
                this.state.monthFromNow = 0
                return
            }
        }

        // Fallback: open on current month
        this.setMonth(0)
    }


    componentDidUpdate(prevProps) {
        // When external value changes, update selected date and calendar position
        if (this.props.data != prevProps.data) {
            const newDate = this.props.data
            this.setState({ title: newDate })

            if (newDate) {
                const selected = moment(newDate)

                if (selected.isValid()) {
                    this.setMonth(0, newDate)
                    this.setState({ monthFromNow: 0 })
                }
            }
        }
    }




    changeMonth(number) {

        const hasFuture = this.props.header?.information?.hasFuture
        const nextOffset = this.state.monthFromNow + number

        // If future dates are not allowed, don't go beyond current month
        if (!hasFuture && nextOffset > 0) {
            return
        }

        this.setMonth(nextOffset)
        this.setState({ monthFromNow: nextOffset })
    }

    changeYear(number) {
        // Jump a full year (12 months) forward or backward
        this.changeMonth(number * 12)
    }

    setMonth(fromNow, startDate) {

        // Normalize offset to stay within supported Jalali range
        const hasFuture = this.props.header?.information?.hasFuture
        const minOffset = -110 * 12
        const maxOffset = hasFuture ? 50 * 12 : 0

        if (!Number.isFinite(fromNow)) {
            fromNow = 0
        }
        if (fromNow < minOffset) {
            fromNow = minOffset
        }
        if (fromNow > maxOffset) {
            fromNow = maxOffset
        }

        // this.setState({month:{}},()=>{



        let now = new Date();
        let days = []



        let start = moment(now).add(fromNow, 'jmonth').startOf('jmonth')


        if (startDate) {

            if (!(typeof startDate == 'string' && startDate.startsWith('{{'))) {

                start = moment(startDate).add(fromNow, 'jmonth').startOf('jmonth')
            } else {
                start = moment(now).add(this.state.monthFromNow, 'jmonth').startOf('jmonth')

            }
        }

        // let end = moment(now).add(fromNow, 'month').endOf('month')
        // let count = 0


        for (let i = 0; i < moment(now).add(fromNow, 'jmonth').daysInMonth(); i++) {

            days.push({ start: moment(start).add(i, 'jday').startOf('jday').valueOf(), end: moment(start).add(i, 'jday').endOf('jday').valueOf() })
            // count++
        }

        // console.log(start)
        // console.log(days)

        // console.log(days)

        // this.setState({ isOpen: false }, () => {
        this.setState({ showDaysComponent: false }, () => {
            this.setState({ month: { title: moment(start).locale('fa').format('jYYYY-jMMMM'), startDay: start.day() + 1, days: days } }, () => {

                this.setState({ showDaysComponent: true })
            })

        })
        // })
        // console.log(start.unix())
        // console.log(end.day())
        // })
    }



    setDay(day) {
        let startOrEnd = this.props.startOrEnd ? this.props.startOrEnd : "start"
        this.setState({ title: day[startOrEnd] })
        // console.log()
        this.props.changeValue(this.props.header.key, day[startOrEnd], this.props.extra)

    }

    setYear(year) {
        // Set date to first day of the selected year (Farvardin 1st for Jalali)
        const yearStart = moment().jYear(year).jMonth(0).jDate(1).startOf('jday')
        this.setState({ title: yearStart.valueOf() })
        this.props.changeValue(this.props.header.key, yearStart.valueOf(), this.props.extra)
        this.setState({ isOpen: false, showYearPicker: false })
    }

    showDays() {

        // let day = 1
        let week = []
        let weeks = []
        let days = []
        let startDay = this.state.month.startDay

        // let firstWeek = true
        let count = 0
        // console.log(startDay)
        for (let i = 0; i < startDay - 1; i++) {
            days.push(null)
        }

        days = [...days, ...this.state.month.days]

        for (let i = 0; i < days.length; i++) {
            // console.log("HERE")
            count++
            week.push(days[i])
            if (count == 7 || i == days.length - 1) {
                weeks.push(week)
                count = 0
                week = []
            }
        }

        // console.log(weeks)

        let lastWeekLenght = weeks[weeks.length - 1].length
        if (lastWeekLenght < 7) {
            for (let i = 0; i < 7 - lastWeekLenght; i++) {
                // console.log("HERE")
                weeks[weeks.length - 1].push(null)
            }
        }


        // console.log(weeks)
        // console.log(weeks)
        count = 0

        return weeks.map((week, index) => {

            // if(index ==  )
            return (
                <div key={index} className="d-flex text-center pl-2 pr-2 w-100" style={{ justifyContent: 'space-between' }}>
                    {week.map((day, index1) => {
                        // console.log(count)
                        if (day == null) {
                            return (
                                <div key={index1} style={{ width: '100%', padding: 10, width: 35 }}>
                                </div>
                            )
                        } else {
                            count++

                            let isToday = (this.state.today >= day.start && this.state.today <= day.end) ? true : false
                            let selectedDay = (this.state.title >= day.start && this.state.title <= day.end) ? true : false

                            let available = true

                            // if (this.props.endDate && day.start > this.props.endDate) {
                            //     available = false
                            // }
                            // if (day.end < this.state.today) {
                            //     available = false
                            // }
                            // if (this.props.startDate && day.end < this.props.startDate) {
                            //     available = false
                            // }
                            return (
                                <div onClick={() => { if (available) this.setDay(day) }} key={index1} style={{ cursor: 'pointer', width: '100%', backgroundColor: selectedDay ? '#007aff' : '#fcfcfc', padding: 0, borderRadius: 40, width: 35, height: 35, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                                    <div style={{ backgroundColor: isToday ? '#007aff20' : 'transparent', borderRadius: 40, padding: 0, minWidth: 25, height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <span style={{ color: available ? (selectedDay ? '#fff' : '#345') : '#abc', fontSize: 12 }}>{count}</span>
                                    </div>
                                </div>
                            )
                        }
                    })
                    }

                </div>
            )
        })




    }


    componentWillUnmount() {
        document.removeEventListener('mousedown', this.closeBox);
        window.removeEventListener('scroll', this.getPosition);

    }

    openBox() {
        console.log("OPENBOX")
        document.addEventListener('mousedown', this.closeBox);
        window.addEventListener('scroll', this.getPosition, true);
        this.getPosition()
        const onlyYear = this.props.header?.information?.onlyYear
        this.setState({ isOpen: true, showYearPicker: onlyYear || false })
    }


    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);

            if (this.refs.icon)
                this.refs.icon.classList.toggle("rotate-180")

        }
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    getPosition = () => {
        // console.log("getPosition")
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left })
    }



    render() {
        let info = this.props.header.information
        const onlyYear = info?.onlyYear

        // console.log(this.state.title)
        let format = this.state.time ? 'jYYYY/jM/jD HH:mm' : 'jYYYY/jM/jD'
        if (onlyYear) {
            format = 'jYYYY'
        }

        return (
            <div className='mt-0 w-100' >
                {/* <label className={'mb-2 mr-1 ml-1 ' + (info.required ? 'required' : '')} style={{ marginBottom: 3, fontSize: 12, marginTop: 5, color: '#999' }}>{info.label}</label> */}
                {/* <input disabled={info.disabled} onChange={e => { this.props.changeValue(this.props.header.key, e.target.value) }} className='form-control' defaultValue={this.props.title} placeholder={info.placeHolder} style={{ backgroundColor: '#f7f7f7', color: '#3b3a40' }} /> */}
                <div className='position-relative' ref={ref => this.setWrapperRef(ref)}>
                    <div onClick={() => { if (!info.disabled) { this.openBox() } }} disabled={info.disabled} onChange={e => { this.props.changeValue(this.props.header.key, e.target.value) }} className='' defaultValue={this.props.title} placeholder={info.placeHolder} style={{ height: 30, color: '#222', display: 'flex', alignItems: 'center', cursor: 'pointer' }} >
                        {this.state.title && (<p>{this.state.title ? `${moment(this.state.title).locale(i18n.language).format(format)}${!onlyYear ? ` (${moment(this.state.title).locale('en').format('YYYY/M/D')})` : ''}` : ''}</p>)}
                        {!this.state.title && (<p style={{ opacity: 0.3 }}>{checkTranslation(info.placeholder)}</p>)}
                    </div>

                    {this.state.isOpen && (
                        <div style={{ position: 'fixed', top: this.state.top, backgroundColor: '#fff', borderRadius: 5, width: '320px', zIndex: 10, boxShadow: '0px 0px 30px rgba(0,0,0,0.1)', padding: 10 }}>
                            {onlyYear ? (
                                // Only show year picker
                                <div
                                    className="mb-1"
                                    style={{
                                        maxHeight: 400,
                                        overflowY: 'auto',
                                        borderRadius: 8,
                                        border: '1px solid #eee',
                                        padding: '6px 4px',
                                        background: '#fafafa',
                                    }}
                                >
                                    {(() => {
                                        const hasFuture = this.props.header?.information?.hasFuture
                                        const info = this.props.header?.information || {}
                                        const todayMoment = moment(this.state.today)
                                        const currentYear = todayMoment.jYear()
                                        const startYear = typeof info.minYear === 'number' ? info.minYear : currentYear - 110
                                        const endYear = typeof info.maxYear === 'number'
                                            ? info.maxYear
                                            : (hasFuture ? currentYear + 50 : currentYear)

                                        // Determine selected year from current title (selected date) if available,
                                        // otherwise fall back to today
                                        const baseMoment = this.state.title
                                            ? moment(this.state.title)
                                            : todayMoment
                                        const selectedYear = baseMoment.jYear()

                                        const years = []
                                        for (let y = endYear; y >= startYear; y--) {
                                            years.push(y)
                                        }
                                        return (
                                            <div className="d-flex flex-wrap justify-content-center">
                                                {years.map((year) => {
                                                    const isSelected = year === selectedYear
                                                    return (
                                                        <button
                                                            key={year}
                                                            type="button"
                                                            className="m-1"
                                                            style={{
                                                                minWidth: 56,
                                                                padding: '4px 10px',
                                                                borderRadius: 999,
                                                                border: isSelected ? '2px solid #10453d' : '1px solid #d1d5db',
                                                                background: isSelected
                                                                    ? 'linear-gradient(135deg, #10453d 0%, #146a5d 100%)'
                                                                    : '#ffffff',
                                                                color: isSelected ? '#ffffff' : '#374151',
                                                                fontSize: 12,
                                                                fontWeight: isSelected ? 600 : 500,
                                                                textAlign: 'center',
                                                                cursor: 'pointer',
                                                                boxShadow: isSelected
                                                                    ? '0 2px 6px rgba(0,0,0,0.15)'
                                                                    : '0 1px 3px rgba(0,0,0,0.08)',
                                                                transition: 'all 0.15s ease-in-out',
                                                            }}
                                                            onClick={() => {
                                                                this.setYear(year)
                                                            }}
                                                        >
                                                            {year}
                                                        </button>
                                                    )
                                                })}
                                            </div>
                                        )
                                    })()}
                                </div>
                            ) : (
                                // Normal date picker with month/day navigation
                                <>
                                    <div className="d-flex p-2" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div className="d-flex align-items-center">
                                            {/* Previous year */}
                                            <img
                                                onClick={() => this.changeYear(-1)}
                                                src="/images/nexts.png"
                                                className={i18n.language == 'fa' ? '' : "rotate-180"}
                                                style={{ opacity: 0.6, marginRight: 6 }}
                                                height="12px"
                                                alt="prev-year"
                                            />
                                            {/* Previous month */}
                                            <img
                                                onClick={() => this.changeMonth(-1)}
                                                src="/images/nexts.png"
                                                className={i18n.language == 'fa' ? '' : "rotate-180"}
                                                height="14px"
                                                alt="prev-month"
                                            />
                                        </div>
                                        <p
                                            style={{ margin: 0, cursor: 'pointer' }}
                                            onClick={() => this.setState({ showYearPicker: !this.state.showYearPicker })}
                                        >
                                            {this.state.month.title}
                                        </p>
                                        <div className="d-flex align-items-center">
                                            {/* Next month */}
                                            <img
                                                onClick={() => this.changeMonth(1)}
                                                src="/images/nexts.png"
                                                className={i18n.language == 'fa' ? "rotate-180" : ''}
                                                height="14px"
                                                alt="next-month"
                                            />
                                            {/* Next year */}
                                            <img
                                                onClick={() => this.changeYear(1)}
                                                src="/images/nexts.png"
                                                className={i18n.language == 'fa' ? "rotate-180" : ''}
                                                style={{ opacity: 0.6, marginLeft: 6 }}
                                                height="12px"
                                                alt="next-year"
                                            />
                                        </div>
                                    </div>

                                    {this.state.showYearPicker && (
                                        <div
                                            className="mt-2 mb-1"
                                            style={{
                                                maxHeight: 200,
                                                overflowY: 'auto',
                                                borderRadius: 8,
                                                border: '1px solid #eee',
                                                padding: '6px 4px',
                                                background: '#fafafa',
                                            }}
                                        >
                                            {(() => {
                                                const hasFuture = this.props.header?.information?.hasFuture
                                                const info = this.props.header?.information || {}
                                                const todayMoment = moment(this.state.today)
                                                const currentYear = todayMoment.jYear()
                                                const startYear = typeof info.minYear === 'number' ? info.minYear : currentYear - 110
                                                const endYear = typeof info.maxYear === 'number'
                                                    ? info.maxYear
                                                    : (hasFuture ? currentYear + 50 : currentYear)

                                                // Determine selected year from current title (selected date) if available,
                                                // otherwise fall back to today
                                                const baseMoment = this.state.title
                                                    ? moment(this.state.title)
                                                    : todayMoment
                                                const selectedYear = baseMoment.jYear()

                                                const years = []
                                                for (let y = endYear; y >= startYear; y--) {
                                                    years.push(y)
                                                }
                                                return (
                                                    <div className="d-flex flex-wrap justify-content-center">
                                                        {years.map((year) => {
                                                            const isSelected = year === selectedYear
                                                            return (
                                                                <button
                                                                    key={year}
                                                                    type="button"
                                                                    className="m-1"
                                                                    style={{
                                                                        minWidth: 56,
                                                                        padding: '4px 10px',
                                                                        borderRadius: 999,
                                                                        border: isSelected ? '2px solid #10453d' : '1px solid #d1d5db',
                                                                        background: isSelected
                                                                            ? 'linear-gradient(135deg, #10453d 0%, #146a5d 100%)'
                                                                            : '#ffffff',
                                                                        color: isSelected ? '#ffffff' : '#374151',
                                                                        fontSize: 12,
                                                                        fontWeight: isSelected ? 600 : 500,
                                                                        textAlign: 'center',
                                                                        cursor: 'pointer',
                                                                        boxShadow: isSelected
                                                                            ? '0 2px 6px rgba(0,0,0,0.15)'
                                                                            : '0 1px 3px rgba(0,0,0,0.08)',
                                                                        transition: 'all 0.15s ease-in-out',
                                                                    }}
                                                                    onClick={() => {
                                                                        const yearDiff = year - selectedYear
                                                                        const fromNow = this.state.monthFromNow + yearDiff * 12
                                                                        this.setMonth(fromNow)
                                                                        this.setState({ monthFromNow: fromNow, showYearPicker: false })
                                                                    }}
                                                                >
                                                                    {year}
                                                                </button>
                                                            )
                                                        })}
                                                    </div>
                                                )
                                            })()}
                                        </div>
                                    )}

                                    <div className="d-flex p-2  text-center w-100" style={{ justifyContent: 'space-between' }}>
                                        {this.state.week.map((prop, index) => {
                                            return (
                                                <div className={'w-100'} style={{ width: 35, }}>
                                                    <p style={{ color: '#789', fontSize: 12 }}>{prop}</p>
                                                </div>
                                            )
                                        })}
                                    </div>

                                    {this.showDays()}
                                </>
                            )}

                        </div>
                    )}

                </div>

            </div>
        );
    }
}

export default DateInput;
